import React, { useEffect, useState } from "react";
import CardPanel from "../card-panel/card-panel";
import CardPanelBody from "../card-panel/card-panel-body";
import "./allocation-card.scss";
import ChartJsChart from "../chartJs/chart";
import { updateCarrierAllocationTEUs } from "../../../services/dataService";
import { toast } from "react-toastify";

function AllocationCard({ item, allowToEdit }) {
	const [value, setValue] = useState(item.LimtForCarriers)
  const [number, setNumber] = useState('');
	const [newData, setNewData] = useState({
		labels: ["", "", "", "", "", "", "", ""],
		datasets: [
			{
				data: [],
				borderColor: "rgb(255, 99, 132)",
				backgroundColor: "#ffffff",
			},
		],
	})
  
  const preventNegativeValues = (e) =>
  {
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  if (/^[a-zA-Z]$/.test(e.key)) {
    e.preventDefault();
  }

   

  if (/^\d*$/.test(value) && value.length <= 4 ) {
    setValue(value);
  }
  }

	const options = {
		responsive: true,
		plugins: {
			legend: {
				display: false,
			},
		},
	};
	useEffect(()=>{
		const data = {
			labels: ["", "", "", "", "", "", "", ""],
			datasets: [
				{
					data: [],
					borderColor: "rgb(255, 99, 132)",
					backgroundColor: "#ffffff",
				},
			],
		};
		data.datasets[0].data.push(
			item.Count_For_Week1 !== null ? item.Count_For_Week1 : 0,
			item.Count_For_Week2 !== null ? item.Count_For_Week2 : 0,
			item.Count_For_Week3 !== null ? item.Count_For_Week3 : 0,
			item.Count_For_Week4 !== null ? item.Count_For_Week4 : 0,
			// item.Count_For_Week5 !== null ? item.Count_For_Week5 : ""
		)
		if(item.Count_For_Week5 !== null){
			data.datasets[0].data.push(
				item.Count_For_Week5 !== null ? item.Count_For_Week5 : 0
			)	
		}
		setNewData(data)
	},[item])
	
	async function onBlur(e) {
    if ((item.LimtForCarriers).toString() !== e.target.value) {
      try {
        await updateCarrierAllocationTEUs({
          id: item.CarrierAll_ID,
          allocation_In_TEUs: e.target.value,
        });
        toast.success(
          `${item.Carrier} allocation in TEU's has been updated with ${e.target.value}`
        );
      } catch (error) {
        toast.error("Something went wrong...please try again");
      }
    }
  }

	return (
    <CardPanel>
      <CardPanelBody>
        <div className="allocation-card-row">
          <div className="allocation-card-left">
            {/* <h3 className="allocation-card-title">Project</h3> */}
            <h2 className="allocation-card-sub-title">{item.Carrier}</h2>
            <p className="allocation-card-planned-label">Planned Count</p>
            <input
              className="allocation-card-planned-value"
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={preventNegativeValues}
              onBlur={onBlur}
              maxLength="4"
			  disabled={!allowToEdit}
            />
            {/* <p className="allocation-card-planned-value">739</p> */}
          </div>
          <div className="allocation-card-right pt-20">
            <div className="allocation-card-card-block">
              <ChartJsChart options={options} data={newData} height="120" />
            </div>
          </div>
          <div className="allocation-card-bottom">
            <div className="allocation-card-row">
              <div className="allocation-card-left">
                <p
                  className="value up"
                  style={{
                    color:
                      item.Count_For_Week1 === null
                        ? "black"
                        : item.Count_For_Week1 < item.LimtForCarriers
                        ? "#04ce00"
                        : "#ff718b",
                  }}
                >
                  {item.Count_For_Week1 ? item.Count_For_Week1 : "0"}
                </p>
                <p className="label ">{item.Week1}</p>
              </div>
              <div className="allocation-card-right">
                <p
                  className="value down"
                  style={{
                    color:
                      item.Count_For_Week2 === null
                        ? "black"
                        : item.Count_For_Week2 < item.LimtForCarriers
                        ? "#04ce00"
                        : "#ff718b",
                  }}
                >
                  {item.Count_For_Week2 ? item.Count_For_Week2 : "0"}
                </p>
                <p className="label ">{item.Week2}</p>
              </div>
              <div className="allocation-card-left">
                <p
                  className="value down"
                  style={{
                    color:
                      item.Count_For_Week3 === null
                        ? "black"
                        : item.Count_For_Week3 < item.LimtForCarriers
                        ? "#04ce00"
                        : "#ff718b",
                  }}
                >
                  {item.Count_For_Week3 ? item.Count_For_Week3 : "0"}
                </p>
                <p className="label ">{item.Week3}</p>
              </div>
              <div className="allocation-card-right">
                <p
                  className="value up"
                  style={{
                    color:
                      item.Count_For_Week4 === null
                        ? "black"
                        : item.Count_For_Week4 < item.LimtForCarriers
                        ? "#04ce00"
                        : "#ff718b",
                  }}
                >
                  {item.Count_For_Week4 ? item.Count_For_Week4 : "0"}
                </p>
                <p className="label ">{item.Week4}</p>
              </div>
              {item.Count_For_Week5 && (
                <div className="allocation-card-left">
                  <p
                    className="value down"
                    style={{
                      color:
                        item.Count_For_Week5 === null
                          ? "black"
                          : item.Count_For_Week5 < item.LimtForCarriers
                          ? "#04ce00"
                          : "#ff718b",
                    }}
                  >
                    {item.Count_For_Week3 ? item.Count_For_Week3 : "0"}
                  </p>
                  <p className="label ">{item.Week5}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </CardPanelBody>
    </CardPanel>
  );
}

export default AllocationCard;
